var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"990b04ba46f8d74207709ee67f7a1b27767adc46"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["widget@swipelux-mh"]={id:"990b04ba46f8d74207709ee67f7a1b27767adc46"};
      